import { SafeImage } from '@/components/common/safe-image';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import usePreloadImage from '@/hooks/use-preload-image';
import { useIsDesktop } from '@/hooks/use-user-platform';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';

export default function ContentImage({ message }: ContentCommonProps) {
  const [url] = message.Message.split('|');
  const isDesktop = useIsDesktop();
  const { src: safeSrc, aspectRatio, dimension } = usePreloadImage(url, { maxWidth: isDesktop ? 0.45 : 0.7 });
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();

  const handleViewImage = () => {
    resetSelectedMessages([message]);
    onInteraction('preview');
  };

  return (
    <div
      className={cn('w-fit flex flex-col max-w-75vw desktop:max-w-50vw', {
        'chat-bubble group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary group-data-sender:items-end':
          Boolean(message.Quote),
      })}>
      {message.Quote && (
        <div style={{ width: dimension[0] ?? '100%' }}>
          <MessageQuote
            className='mb-1 w-full'
            quote={message.Quote}
          />
        </div>
      )}

      <div
        className='relative max-w-75vw desktop:max-w-50vw min-h-16 min-w-16'
        style={{
          maxWidth: dimension[0] || '100%',
          maxHeight: dimension[1] || 'auto',
        }}>
        <SafeImage
          src={safeSrc}
          displaySize='fixed'
          style={{
            aspectRatio: aspectRatio || 'auto',
            width: 'auto',
            maxWidth: dimension[0] || '100%',
            maxHeight: dimension[1] || 'auto',
            backgroundColor: 'transparent',
          }}
          className='rounded-md min-w-16 min-h-16 bg-contain desktop:h-full'
        />

        <button
          type='button'
          className='absolute inset-0 z-10 flex cursor-pointer items-end justify-end rounded-lg data-quote:hidden'
          onClick={handleViewImage}
        />
      </div>
    </div>
  );
}
